export default __webpack_public_path__ + "static/media/7A2_cordry_414_scan2.63eb2d51.png";